export default {
    see: "See",
}
